import React, { PureComponent } from 'react';

import PartnerHeaderComponent from './component';
import { getPartnerWebsite } from '../../../utils/partnerSession';

class PartnerHeaderContainer extends PureComponent {
  onPartnerLogoClick = () => {
    const partnerWebiste = getPartnerWebsite(this.props.partnerSession);
    if (partnerWebiste) {
      window.open(partnerWebiste, '_blank');
    }
  };

  render() {
    return (
      <PartnerHeaderComponent
        onPartnerLogoClick={this.onPartnerLogoClick}
        {...this.props}
      />
    );
  }
}
export default PartnerHeaderContainer;
